export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.portofilo.app',
};
